/**
 * Cost info for scale drop form.
 * For Media Devoted | Created By Ciro Autiero
 */

export function computeScaleDropCostInfo(
  pricePerSms: number | null | undefined,
  amount: number | '',
  isMulti: boolean,
  rowsCount: number,
): { perSms: number; total: number } | null {
  if (pricePerSms == null || Number.isNaN(pricePerSms)) return null;
  const amt = amount !== '' && amount >= 1 ? amount : 0;
  if (amt <= 0) return null;
  return { perSms: pricePerSms, total: amt * pricePerSms * (isMulti ? rowsCount : 1) };
}
